/**
 * Created by mestrad on 2018. 06. 28..
 */

export default Geo;

import Base from "./Base";
import Map from "../../Map";
import TimeLine from "../../TimeLine";
import AutoComplete from "../../AutoComplete";

const $ = jQuery;

function Geo(config) {
    Base.call(this, config);
    var self = this;
    var searchMap;
    var searchTimeLine;
    var placeholderList;
    var mapFilter = false;
    var timeLineFilter = false;
    var filterCount = 0;
    var categoryList;
    var notAutoCompleteTypeList = ["map", "timeline"];
    var nameSpaceConnectionTypeList = ["parent"];

    function render(placeholders) {
        placeholderList = placeholders;
        addSearchMap();
        addSearchTimeLine();
        initEvents();
    }

    function createFilter() {
        if ($("#nnpSearchSelectContainer").length) {
            self.addFilter(config.domElements.wrapperSelector, filterCount,
                self.getFilterTypes(categoryList, getExtraFilterTypes()),
                "#" + self.getSelectId(filterCount, "Types"));
            var activeOption = self.getFilterTypes(categoryList, getExtraFilterTypes())[0].id;
            var newFilterId = "#" + self.getSelectId(filterCount, "Types");
            initFilterEvents();
            var newWrapper = $(newFilterId).parent().find(".filterSelectWrapper");
            refreshFilterWrapper(newWrapper, activeOption);
            return;
        }
        filterCount = 0;
        var formCode = '<div id="nnpSearchSelectContainer">';
        self.getOptionList('category-types', function (categories) {
            categoryList = categories;
            var filterTypes = self.getFilterTypes(categories, getExtraFilterTypes());
            formCode += self.createSelect(filterTypes, config.domElements.filterTypesId, config.domElements.filterTypesClass) + '<div class="filterSelectWrapper">';
            placeholderList.$wrapperObj.html(formCode);
            checkSelectedOption();

            if (!timeLineFilter && !mapFilter) {
                var holderInput = self.createAutoCompleteInput(config.domElements.filterOptionsId + "helper");
                formCode += holderInput;
                if (filterTypes[0].id === "identifier") {
                    formCode += self.createInput(config.domElements.filterOptionsId + "_value");
                }
                formCode += self.createRelationSelect(filterCount) + '</div>';
            } else {
                if (mapFilter) {
                    $("#searchMap").trigger("filterOn");
                    formCode += '<div class="nnp_info">A térképen a <span' +
                        ' class="leaflet-draw-draw-rectangle"></span> gombra' +
                        ' kattintva jelölje ki a területet, amelyen belül' +
                        ' szeretne keresni.</div>';
                } else {
                    $("#searchMap").trigger("filterOff");
                }
                if (timeLineFilter) {
                    $(config.domElements.searchTimeLineSelector.timeLineContainerSelector).removeClass("nnpHidden");
                    var dateIntervall = self.createDateIntervall(config);
                    formCode += dateIntervall.code + "</div>";
                }
            }
            formCode += self.createAddAndRemoveBtn() + '</div>';
            placeholderList.$wrapperObj.html(formCode);

            if (dateIntervall) {
                dateIntervall.initDatepicker();
                searchTimeLine.refresh();
                setTimeout(function () {
                    searchTimeLine.addFilterCustomTime(new Date("1900-01-01"), Date.now());
                }, 1000);
            }
            if ($.inArray(filterTypes[0].id, notAutoCompleteTypeList) === -1) {
                AutoComplete({
                    holderItem: "#" + config.domElements.filterOptionsId + "helper",
                    ajaxUrl: config.ajaxUrl,
                    objectType: "geo",
                    locale: config.locale,
                    type: nameSpaceConnectionTypeList.indexOf(filterTypes[0].id) > -1 ? "search" : "category-types",
                    categoryType: filterTypes[0].id,
                });
            }
            initFilterEvents();
        });
    }

    function getExtraFilterTypes() {
        var extraFilters = [];
        if (!mapFilter) {
            extraFilters.push({
                "title": "Térkép",
                "id": "map"
            });
        }
        /*
        if (!timeLineFilter) {
            extraFilters.push({
                "title": "Intervallum",
                "id": "timeline"
            });
        }
         */
        extraFilters.push({
            "title": "Felettes",
            "id": "parent"
        });
        return extraFilters;
    }

    function addSearchTimeLine() {
        if (searchTimeLine == undefined) {
            searchTimeLine = new TimeLine({
                locale: config.locale,
                objectType: config.objectType,
                type: "search",
                selectors: {
                    elementId: placeholderList.$searchTimeLine[0].timeLineSelector,
                    zoomInId: placeholderList.$searchTimeLine[0].zoomInSelector,
                    zoomOutId: placeholderList.$searchTimeLine[0].zoomOutSelector,
                    moveLeftId: placeholderList.$searchTimeLine[0].moveLeftSelector,
                    moveRightId: placeholderList.$searchTimeLine[0].moveRightSelector,
                },
                domElements: config.domElements,
            });
            searchTimeLine.refresh();
            $(config.domElements.searchTimeLineSelector.timeLineContainerSelector).addClass("nnpHidden");
        }
    }

    function addSearchMap() {
        if (searchMap == undefined) {
            searchMap = new Map({
                elementId: placeholderList.$searchMap[0].id,
                domElements: config.domElements,
                type: "search",
            });
            searchMap.refresh();
        }
    }

    function initEvents() {
        config.$baseForm.on("searchResultReceived", function (event, receivedData) {
            searchMap.refresh(receivedData);
        });
        config.$baseForm.on("change", "#nnp_search_date_from, #nnp_search_date_to", function () {
            var dateFromPicker = $(config.domElements.searchDateFrom);
            var dateToPicker = $(config.domElements.searchDateTo);
            $(".nnpSearchDateIntervallContainer").children(".nnp_error_message").remove();
            if (dateFromPicker.datepicker("getDate") < dateToPicker.datepicker("getDate")) {
                searchTimeLine.setFilterCustomTime(
                    dateFromPicker.datepicker("getDate"),
                    dateToPicker.datepicker("getDate")
                );
            } else {
                $(".nnpSearchDateIntervallContainer").append('<div class="nnp_error_message">A kezdő dátum nem lehet nagyobb a vég dátumnál.</div>');
                searchTimeLine.revertFilterDateIntervall();
            }
        });
    }

    function initFilterEvents() {
        var addBtn = $(".addFilterBtn");
        var removeBtn = $(".removeFilterBtn");
        var filterTypeSelect = $("#" + self.getSelectId(filterCount, "Types"));
        addBtn.off("click");
        removeBtn.off("click");
        addBtn.on("click", function () {
            var activeOption = self.getFilterTypes(categoryList, getExtraFilterTypes())[0].id;
            var newFilterId = "#" + self.getSelectId(filterCount, "Types");
            self.addFilter(config.domElements.wrapperSelector, filterCount,
                self.getFilterTypes(categoryList, getExtraFilterTypes()),
                newFilterId);
            initFilterEvents();
            var newWrapper = $(newFilterId).parent().find(".filterSelectWrapper");
            refreshFilterWrapper(newWrapper, activeOption);
        });
        removeBtn.on("click", function () {
            self.removeFilter(this);
            checkSelectedOption();
            self.refreshSearchWrapper(self.getFilterTypes(categoryList, getExtraFilterTypes()));
            if (!timeLineFilter) {
                searchTimeLine.removeFilterCustomTime();
                $(config.domElements.searchTimeLineSelector.timeLineContainerSelector).addClass("nnpHidden");
            }
            if (!mapFilter) $("#searchMap").trigger("filterOff");
        });
        filterTypeSelect.on("change", function () {
            refreshAllSelectOptions(filterTypeSelect.val(), "#" + filterTypeSelect.attr("id"), filterTypeSelect.parent());
        });
        filterCount++;
    }

    function refreshAllSelectOptions(value, selectId, parent) {
        refreshFilterWrapper(parent.find(".filterSelectWrapper"), value);
        self.refreshSearchWrapper(self.getFilterTypes(categoryList, getExtraFilterTypes()), selectId);
    }

    function refreshFilterWrapper(wrapper, value) {
        checkSelectedOption();
        if (!$.inArray(value, notAutoCompleteTypeList) < 0) {
            appendFilterInput(wrapper, value);
            // appendFilterSelect( wrapper, value );
        } else {
            if (value == "map") {
                $("#searchMap").trigger("filterOn");
                wrapper.children().remove();
                wrapper.append('<div class="nnp_info">A térképen a <span' +
                    ' class="leaflet-draw-draw-rectangle"></span> vagy a' +
                    ' <span class="leaflet-draw-draw-circle"></span> gombra' +
                    ' kattintva jelölje ki a területet, amelyen belül' +
                    ' szeretne keresni.</div>');
            } else if (value == "timeline") {
                $(config.domElements.searchTimeLineSelector.timeLineContainerSelector).removeClass("nnpHidden");
                wrapper.children().remove();
                var dateIntervall = self.createDateIntervall(config);
                wrapper.append(dateIntervall.code);
                dateIntervall.initDatepicker();
                searchTimeLine.refresh();
                setTimeout(function () {
                    searchTimeLine.addFilterCustomTime(new Date("1900-01-01"), Date.now());
                }, 1000);
            } else {
                appendFilterInput(wrapper, value);
            }
        }
        if (!mapFilter) $("#searchMap").trigger("filterOff");
        if (!timeLineFilter) {
            $(config.domElements.searchTimeLineSelector.timeLineContainerSelector).addClass("nnpHidden");
            searchTimeLine.removeFilterCustomTime();
        }
    }

    function appendFilterSelect(wrapper, value) {
        var filterTypes = self.getFilterTypes(categoryList, getExtraFilterTypes());
        filterTypes.forEach(function (item) {
            if (item.id == value) {
                var selectId = wrapper.children().attr("id") || self.getSelectId(filterCount - 1, "Options");
                wrapper.children().remove();
                if (value == "identifier") {
                    wrapper.append(self.createSelect(self.getCategoryItems(value, categoryList), selectId, config.domElements.filterOptionsClass)
                        + self.createInput(selectId + "_value")
                        + self.createRelationSelect(filterCount - 1));
                } else {
                    wrapper.append(self.createSelect(self.getCategoryItems(value, categoryList), selectId, config.domElements.filterOptionsClass) +
                        self.createRelationSelect(filterCount - 1));
                }
            }
        });
    }

    function appendFilterInput(wrapper, value) {
        var helperArray = wrapper.prev().attr("id").split('_');
        var filterIndex = helperArray.length === 1 ? 0 : helperArray[helperArray.length -1];
        var filterTypes = self.getFilterTypes(categoryList, getExtraFilterTypes());
        filterTypes.forEach(function (item) {
            if (item.id === value) {
                var selectId = self.getSelectId(filterIndex, "Options");
                var holderInput = self.createAutoCompleteInput(selectId + "helper");
                var plusInput = item.id === "identifier" ? self.createInput(selectId + "_value") : "";
                wrapper.children().remove();
                wrapper.append(holderInput + plusInput +
                    self.createRelationSelect(filterIndex));
                AutoComplete({
                    holderItem: "#" + selectId + "helper",
                    ajaxUrl: config.ajaxUrl,
                    objectType: "geo",
                    locale: config.locale,
                    type: nameSpaceConnectionTypeList.indexOf(item.id) > -1 ? "search" : "category-types",
                    categoryType: item.id
                });
            }
        });
    }

    function checkSelectedOption() {
        mapFilter = false;
        timeLineFilter = false;
        $("#customSearchWrapper select").each(function () {
            var item = $("#" + this.id);
            if (item.hasClass(config.domElements.filterTypesClass)) {
                if (item.val() == "map") {
                    mapFilter = true;
                }
                if (item.val() == "timeline") {
                    timeLineFilter = true;
                }
            }
        });
    }

    return {
        render: render,
        createFilter: createFilter
    };
}

Geo.prototype = Object.create(Base.prototype);